import { render, staticRenderFns } from "./single-message.vue?vue&type=template&id=09d72988&scoped=true&"
import script from "./single-message.vue?vue&type=script&lang=js&"
export * from "./single-message.vue?vue&type=script&lang=js&"
import style0 from "./single-message.vue?vue&type=style&index=0&id=09d72988&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d72988",
  null
  
)

export default component.exports